module.exports = __webpack_public_path__ + "static/img/logo_092.a5e1eabf.png";